
import Polyswarm from "../../../assets/outline/Polyswarm.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PolyswarmIcon({ className, dataTestid = "PolyswarmIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Polyswarm data-testid={dataTestid} className={classes} {...rest} />
  );
}
